module.exports = __webpack_public_path__ + "static/media/add department.11acbdff.svg";